import React from 'react';
import { Card, Col, Row } from 'antd';
import { useUnit } from 'effector-react';
import MapBlock from '../../components/MapBlock/MapBlock.jsx';
import ProfileModal from '../../components/RbpLiteComponents/ProfileModal/ProfileModal.jsx';
import LiteErrorModal from '../../components/RbpLiteComponents/LiteErrorModal/LiteErrorModal.jsx';
import ChatModal from '../../components/ChatModal/ChatModal.jsx';
import CreateConfirmModal from '../../components/RbpLiteComponents/CreateConfirmModal/CreateConfirmModal.jsx';
import PublicInfoModal from '../../components/PublicInfoModal/PublicInfoModal.jsx';
import RestoreModal from '../../components/RbpLiteComponents/RestoreModal/RestoreModal.jsx';
import { $isBot } from '../../models/authModel/index.js';

function RbpLitePage() {
  const isBot = useUnit($isBot);
  return (
    <>
      <Row gutter={[20, 0]} style={{ height: '100%' }}>
        <Col style={{ width: '100%' }}>
          <Card className="map_card" bodyStyle={{ height: '100%' }}>
            <MapBlock />
          </Card>
        </Col>
      </Row>
      <ProfileModal />
      <LiteErrorModal />
      <CreateConfirmModal />
      <PublicInfoModal />
      <RestoreModal />
      {isBot && (
        <div
          id="map_screenshot"
          style={{
            position: 'absolute',
            top: 69,
            left: 467,
            width: 977,
            height: 849,
          }}
        />
      )}
    </>
  );
}

export default RbpLitePage;
